export default __webpack_public_path__ + "static/media/image.winsmart-solutions.9a4145c5.png";